import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LeaveReportType } from 'app/modules/common/enums/leave-report-enums';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ReportTypes } from 'app/modules/reports/enums/report-types';
import { ReportsCommonService } from 'app/modules/reports/services/reports-common.service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-leave-report-popup',
    templateUrl: './leave-report-popup.component.html',
    styleUrls: ['./leave-report-popup.component.scss'],
    standalone: false
})
export class LeaveReportPopupComponent implements OnInit {

    constructor(
        private dialogRef: MatDialogRef<LeaveReportPopupComponent>,
        public reportsCommonService: ReportsCommonService,
        private pageLoaderService: PageLoaderService,
        private fileExportService: FileExportService,
        private sharedService: SharedService,
    ) { }

    ngOnInit(): void {
        this.reportsCommonService.SelectedReport = ReportTypes.Leave;

        // set empressa ID
        this.reportsCommonService.empresaId = JSON.parse(localStorage.getItem('Empresa'));

        // set employee id 
        this.reportsCommonService.trabajadorId = 0;

        // set leave report type
        this.reportsCommonService.leaveReportType = LeaveReportType.Selection;
    }

    public close(): void {
        this.dialogRef.close();
    }

    public generateReport(): void {
        this.pageLoaderService.ShowPageLoader();
        this.reportsCommonService.generateReport()
            .pipe(
                finalize(() => this.pageLoaderService.HidePageLoader())
            )
            .subscribe(res => {
                res = res.body;

                if (res.code === 0) {

                    // get downloadable file info
                    const fileInfo = res.result;
                    // download file
                    this.fileExportService.DownloadFile(fileInfo.file, fileInfo.fileName);

                } else {
                    this.sharedService.ShowSnackBar("lo siento, el proceso falló");
                    console.error("Server Error: " + res.message);
                }

            }, error => {
                console.error(error);
            });
    }

}
